import React from 'react';

import useCanViewEventDebugger from 'app/event-monitoring/event-debugger/useCanViewEventDebugger';

import OpenEventDebuggerButton from './OpenEventDebuggerButton';

export default function GatedOpenEventDebuggerButton(props) {
  const { canViewEventDebugger } = useCanViewEventDebugger();

  if (!canViewEventDebugger) {
    return null;
  }

  return <OpenEventDebuggerButton {...props} />;
}

GatedOpenEventDebuggerButton.propTypes = OpenEventDebuggerButton.propTypes;
